import React from 'react';
import '../../FormBuilder.css';

const TwoDMultiScanElement = ({ component, isRequired }) => {
  const renderElement = () => {
    return (
      component.elementName === '2dMultiScan' && (
        <label className='titleTextLbl'>
            {component.fieldName || "2D Multi Scan"}
            <span className='requiredContainer' style={{ color: 'red' }}>{isRequired(component)}</span>
        </label>
      )
    );
  };

  return (
    <div className='renderAllElements'>
      {renderElement()}
    </div>
  );
};

export default TwoDMultiScanElement;
